import { Button, Flex, Grid, Text, useLayout } from '@approvalmax/ui/src/components';
import { useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { routingService } from 'services/routing';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { getPath, getWebsiteUrl, Path } from 'urlBuilder';

import { KycStatusLayout } from '../../resources/components';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ hasHeader: true, hasDrawer: true });

    const company = useCompanyBasedOnUrl();

    const handleClick = useCallback(() => {
        routingService.push(getPath(Path.wallets, company.id));
    }, [company.id]);

    return (
        <KycStatusLayout
            content={
                <>
                    <Helmet title={messages.pageTitle({ companyName: company?.displayName })} />

                    <Grid gap={16}>
                        <Text font='headline' fontSize='xxsmall' fontWeight='medium'>
                            {messages.title}
                        </Text>

                        <Text font='body' fontSize='medium' fontWeight='regular'>
                            {messages.weArePleased({
                                br: <br />,
                                terms: (
                                    <a href={`${getWebsiteUrl(false)}terms`} target='_blank'>
                                        {messages.terms}
                                    </a>
                                ),
                            })}
                        </Text>

                        <Text font='body' fontSize='medium' fontWeight='regular'>
                            {messages.beAdvised}
                        </Text>

                        <Flex justifyContent='end'>
                            <Button color='blue80' onClick={handleClick}>
                                {messages.accept}
                            </Button>
                        </Flex>
                    </Grid>
                </>
            }
        />
    );
};

export default Page;
